// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__duf3k","copyright":"Footer_copyright__c5EkT","disclaimer":"Footer_disclaimer__g9rPv","warning":"Footer_warning__8mW5G"};